<template>
  <div class="container-fluid">
    <div class="assessment-lesson-list">
      <div class="row bottom-dotted-border">
        <div class="col-md-12 col-lg-12 padding-right-0px padding-top-15px">
          <ul class="col-md-12 col-lg-12 text-align-left padding-left-0px padding-right-0px">
            <li class="padding-3px">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <span class="filled-circle col-md-1 col-lg-1 cursor-pointer text-color-white">
                    <!-- {{(currRenderedModuleObj.DbIndex) + 1}} -->
                    <input type="checkbox" v-model="getIsLessonSelectedValue">
                  </span>
                  <span class="col-md-11 col-lg-11">
                    Lesson {{(currRenderedModuleObj.DbIndex) + 1}}:
                  </span>
                </div>
              </div>
              <div class="row font-weight-bold font-size-17px">
                <div class="col-md-12 col-lg-12 padding-left-58px">
                  {{getCurrentlyRenderedLessonObj.Title}}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <update-assessment-step-list v-for='currElementObj in currRenderedModuleObj.ElementObj' :key="currElementObj.ElementId" :currComponentElementObj="currElementObj" :parentElementObj="lessonObj" :currRenderedModuleObj="currRenderedModuleObj" :lessonObj="getParentLessonObj" :mcqAssessmentObj="mcqAssessmentObj" :currIndex="currIndex" :completedLessonStepList="completedLessonStepList" @isLessonSelected="updateIsLessonSelected"></update-assessment-step-list>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="performAction"></confirmation-alert>
  </div>
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import AlertBox from '@/components/AlertOverlay'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import UpdateAssessmentStepList from '@/components/UpdateAssessmentStepList'
import filter from 'lodash/filter'
import findIndex from 'lodash/findIndex'
import find from 'lodash/find'
export default {
  props: ['parentElementObj', 'lessonObj', 'mcqAssessmentObj', 'currIndex', 'currRenderedModuleObj', 'completedLessonStepList'],
  created: function () {
    this.setDefaultValues()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      showConfirmationBox: false,
      prefixString: '',
      postString: '',
      isLessonSelected: false
    }
  },
  name: 'assessment-lesson-list',
  methods: {
    setDefaultValues: function () {
      this.isLessonSelected = (this.getAssessmentElementListToPost.length === this.getCurrentlyRenderedLessonObj.ElementObj.length && this.getCurrentlyRenderedLessonObj.ElementObj.length > 0)
    },
    performAction (value) {
      this.showConfirmationBox = false
      if (value) {}
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of confirmation overlay
      this.showConfirmationBox = value
    },
    addRemoveStepsFromMainList: function (currSelectedValue) {
      filter(this.currRenderedModuleObj.ElementObj, (obj) => {
        var foundIndex = findIndex(this.getAssessmentElementListToPost, (selectedElementId) => {
          return selectedElementId === obj.ElementId
        })
        if (foundIndex > -1) {
          if (!currSelectedValue) {
            console.log('Trying to remove existing step: ' + foundIndex)
            this.getAssessmentElementListToPost.splice(foundIndex, 1)
          } else {
            console.log('Already had current element in the list at position: ' + foundIndex)
          }
        } else {
          console.log('Trying to add new step: ' + foundIndex)
          this.getAssessmentElementListToPost.push(obj.ElementId)
        }
      })
    },
    updateIsLessonSelected (value) {
      this.isLessonSelected = value
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'confirmation-alert': ConfirmationOverlay,
    'update-assessment-step-list': UpdateAssessmentStepList
  },
  computed: {
    getParentLessonObj: {
      get: function () {
        return this.lessonObj
      }
    },
    getCurrentlyRenderedLessonObj: {
      get: function () {
        return this.currRenderedModuleObj
      }
    },
    getAssessmentElementListToPost: {
      get: function () {
        var currSelectionObj = find(this.$store.state.assessmentElementListToPost, (obj) => {
          return obj.MCQElementId === this.mcqAssessmentObj.ElementId
        })
        return currSelectionObj.ElementListForPersonalization
      },
      set: function (newValue) {
        var currSelectionObj = find(this.$store.state.assessmentElementListToPost, (obj) => {
          return obj.MCQElementId === this.mcqAssessmentObj.ElementId
        })
        currSelectionObj.ElementListForPersonalization = newValue
      }
    },
    getIsLessonSelectedValue: {
      get: function () {
        return this.isLessonSelected
      },
      set: function (newValue) {
        this.addRemoveStepsFromMainList(newValue)
        this.isLessonSelected = newValue
      }
    }
  }
}
</script> 
<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-5Perc
{
	margin-bottom: 5%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-top-2Perc
{
	margin-top: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 25%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer !important;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.border-red {
    border:1px solid red;
}
.margin-bottom-2Perc {
    margin-bottom: 2%;
}
.font-size-14px {
    font-size: 14px;
}
.padding-right-6px {
    padding-right:6px; 
}
.padding-top-1Perc {
    padding-top:1%;
}
.padding-left-0px {
    padding-left:0px;
}
.margin-left-10px {
    margin-left: 10px;
}
.padding-3px {
    padding:3px;
}
.padding-bottom-3px {
  padding-bottom:3px;
}
.padding-left-8px {
  padding-left:8px;
}
ul {
  list-style-type: none;
}
.filled-circle {
  height: 25px;
  width: 25px;
  background-color: #34495e;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
  padding: 2px;
}
.cursor-default {
  cursor:default;
}
.margin-bottom-10px {
  margin-bottom:10px;
}
.background-color-green {
    background-color: #0D9335;
}
.text-color-white {
  color:white;
}
.padding-left-58px {
  padding-left:58px;
}
.font-weight-bold {
  font-weight: bold;
}
.font-size-17px {
  font-size:17px;
}
.bottom-dotted-border {
  border-bottom: 1px dotted #aaa !important;
}
.padding-top-15px {
  padding-top:15px;
}
</style>



// WEBPACK FOOTER //
// src/components/UpdateAssessmentLessonList.vue